import { Reducer } from "redux";

import {
    SIGNUP_LOAD_API_FAILURE,
    SIGNUP_LOAD_API_REQUEST,
    SIGNUP_LOAD_API_SUCCESS,
    SignupLoadApiFailureAction,
    SignupLoadApiRequestAction,
    SignupLoadApiSuccessAction,
} from "@/mk2/apps/users/containers/Signup/Signup.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface SignupPageState {
    loadingState: LoadingState;
    errorMessage: string;
    contentItemTop: number;
    contentItemBottom: number;
}

export const initialSignupPageState: SignupPageState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    contentItemTop: null,
    contentItemBottom: null,
};

export interface SignupPagesState {
    [key: string]: SignupPageState;
}

export const initialSignupPagesState: SignupPagesState = {};

type SignupLoadActions =
    | SignupLoadApiRequestAction
    | SignupLoadApiSuccessAction
    | SignupLoadApiFailureAction;

export const signupReducer: Reducer<SignupPagesState> = (
    state: SignupPagesState = initialSignupPagesState,
    action: SignupLoadActions,
) => {
    const key = action.contentItemsKey;
    const subState = state[key] || initialSignupPageState;
    switch (action.type) {
        case SIGNUP_LOAD_API_REQUEST:
        case SIGNUP_LOAD_API_FAILURE:
            return tupdate(state, {
                [key]: tupdate(subState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });

        case SIGNUP_LOAD_API_SUCCESS: {
            if (!key) {
                return state;
            }

            return tupdate(state, {
                [key]: tupdate(subState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                    contentItemTop: action.response.result.contentItemTop,
                    contentItemBottom: action.response.result.contentItemBottom,
                }),
            });
        }

        default:
            return state;
    }
};
